/**
 * Shared section header for the bookings list: a category icon inline with the
 * title (`font-display`), an optional bullet-separated subtitle, and an
 * optional right-aligned action.
 */

import type { IconName } from '#ui/MaterialIcon.js';

import React from 'react';

import { IconSizes, MaterialIcon } from '#ui/MaterialIcon.js';

export function SectionHeader({
  icon,
  title,
  subtitle,
  action,
}: {
  icon: IconName;
  title: React.ReactNode;
  subtitle?: string[];
  action?: React.ReactNode;
}): React.ReactNode {
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 mb-4">
      <div className="flex items-center gap-3 min-w-0">
        <div className="min-w-0">
          <h3 className="flex items-center gap-2 text-primary font-display text-lg break-words">
            <MaterialIcon icon={icon} size={IconSizes.sm} className="shrink-0" />
            <span className="break-words">{title}</span>
          </h3>
          {subtitle && subtitle.length > 0 && (
            <div className="flex flex-wrap items-center gap-x-1.5 text-muted-foreground text-xs mt-0.5">
              {subtitle.map((part, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <span aria-hidden="true">·</span>}
                  <span>{part}</span>
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
      {action}
    </div>
  );
}
